const voomModals = document.getElementById("voomModals");


/**
 *
 */
const init = function () {

	if (voomModals) {

		const modals = voomModals.querySelectorAll('.voom-modal');

		modals.forEach((el) => {

			const modalId = el.id;
			const triggerClass = '.' + modalId;
			const trigger = document.querySelector(triggerClass);

			if (trigger) {
				const wrapper = document.createElement('a');
				wrapper.setAttribute('class', 'voom-modal-trigger');
				wrapper.setAttribute('href', 'javascript:;');
				wrapper.setAttribute('data-fancybox', '');
				wrapper.setAttribute('data-src', '#' + modalId);
				wrapWith(trigger, wrapper);
			}

		});

	}

};


/**
 * Wraps an element with another element
 */
const wrapWith = function (el, wrapper) {
	el.parentNode.insertBefore(wrapper, el);
	wrapper.appendChild(el);
}


const api = {
	init: init
};

export default api;
